import { render, staticRenderFns } from "./update-appoint.vue?vue&type=template&id=86ce9cf0&scoped=true&"
import script from "./update-appoint.vue?vue&type=script&lang=js&"
export * from "./update-appoint.vue?vue&type=script&lang=js&"
import style0 from "./update-appoint.vue?vue&type=style&index=0&id=86ce9cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ce9cf0",
  null
  
)

export default component.exports